<template>
  <section class="login">
    <div class="login-bg">
      <div class="top-bg">
        <img src="../assets/img/tree-left.png" alt />
        <img src="../assets/img/deng.png" alt />
        <div class="wechat-qrcode">
          <div id="wc-content"></div>
        </div>
        <img src="../assets/img/tree-right.png" alt />
      </div>
      <div class="bottom-bg"></div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {
    const obj = new WxLogin({
      id: "wc-content",
      appid: "wxe6370a679a0ba2db",
      scope: "snsapi_login",
      redirect_uri:
        "https://home.51point.com/51point-0.0.1-SNAPSHOT/wxlogin/WxLoginForPc"
    });
    // TODO
    // document.cookie =
    //   "headimage=http://thirdwx.qlogo.cn/mmopen/vi_32/lemXo2e6chCvFV3zQxj5tqiahAdspeChcOKLY8odnuXOLAcRkgvh3Qqw0PnbIskiaBzfQW3PM9TrgufNPPgNfNwg/132";
    // document.cookie = "nickname=ifangcy";
    // document.cookie =
    //   "unionId=73e46ce9c516c408a4d34b04bb22cec8d1ec8c0471e84a76a7553830cb6ffe8f";
  }
};
</script>

<style scoped>
.login-bg {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.top-bg {
  height: 80%;
  background: #535572;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
}

.bottom-bg {
  height: 100px;
  background: #ffc315;
}

#wc-content {
  width: 100%;
  text-align: center;
}

.wechat-qrcode {
  width: 360px;
  height: 440px;
  background: #fff;
  padding: 30px 20px 0;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.1);
  margin: 10px;
  margin-top: 100px;
}

/* 手机 */
@media screen and (max-width: 768px) {
  .top-bg img {
    display: none;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .top-bg img {
    display: none;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
}
</style>
